module.exports = __webpack_public_path__ + "img/ti.8a2a4b61.svg";